let TimeoutHandler = {};

TimeoutHandler.start = (tm) => {
  if (tm.timeoutRemaining !== undefined)
  {
    tm.timeoutStart = new Date().getTime();
    if (tm.timeout !== undefined)
      window.clearTimeout(tm.timeout);
    tm.timeout =  window.setTimeout(tm.method, tm.timeoutRemaining);
  }
};


TimeoutHandler.pause = (tm) => {
  if (tm.timeout !== undefined)
  {
    let now = new Date().getTime();
    let diff = now - tm.timeoutStart;

    if (tm.timeoutRemaining > diff)
    {
      tm.timeoutRemaining -= diff;
    }
    else
      tm.timeoutRemaining = undefined;

    window.clearTimeout(tm.timeout);
    tm.timeout = undefined;
    tm.timeoutStart = undefined;
  }
};

TimeoutHandler.resume = (tm) => {
  if (tm.timeoutRemaining !== undefined)
  {
    TimeoutHandler.start(tm);   
  }
};

TimeoutHandler.stop = (tm) => {
  if (tm.timeout !== undefined)
  {
    tm.timeoutStart = undefined;
    tm.timeoutRemaining = undefined;
    window.clearTimeout(tm.timeout);
    tm.timeout = undefined;
  }
};

TimeoutHandler.setInterval = (config) => {
  config.interval =  window.setTimeout(config.method, config.duration);
};

TimeoutHandler.clearInterval = (config) => {
  if (config.interval) {
    window.clearInterval(config.interval);
  }
};

module.exports = TimeoutHandler;


// WEBPACK FOOTER //
// ./src/js/services/TimeoutHandler.js